import { pluralizeStr } from '@/api/utils/pluralize'
import { Emoji } from '@/app/components/Emoji/Emoji'
import { Col, Row } from '@/app/components/Flex/Flex'
import { Text } from '@/app/components/Text/Text'
import { UI } from '@/app/components/UI/UI'
import classNames from 'classnames'
import type { FunctionalComponent } from 'preact'
import styles from './index.module.scss'

export type OfferItemProps = {
  clickable?: boolean
  active?: boolean
  type: 'violet' | 'yellow' | 'pink'
  badge?: string | null
  badgeType?: 'orangeGr' | 'pinkGr' | null
  amount: number
  originalPrice?: number | null
  messages: number
  onClick?: () => void
}

export const OfferItem: FunctionalComponent<OfferItemProps> = props => {
  return (
    <UI.Panel
      radius='s'
      clickable={props.clickable}
      type={props.type}
      class={styles.panel}
      shadow={props.active}
      onClick={props.onClick}
    >
      {props.badge && (
        <UI.Badge
          type={props.badgeType ?? 'ghost'}
          class={styles.badge}
        >
          {props.badge}
        </UI.Badge>
      )}

      <Col gap={5}>
        {props.onClick && (
          <Radio
            type={props.type}
            active={props.active}
          />
        )}

        <Row gap={10} flexGrow={1}>
          <Col alignItems='center' justifyContent='space-between'>
            <Col gap={10}>
              <Text
                fontSize={18}
                fontSizeMobile={16}
                fontWeight={600}
                lineHeight={1}
              >
                {props.amount} ₽
              </Text>
              {props.originalPrice && (
                <Text
                  fontSize={14}
                  fontSizeMobile={13}
                  opacity={0.5}
                >
                  <s>{props.originalPrice} ₽</s>
                </Text>
              )}
            </Col>
          </Col>

          <Text
            fontSize={16}
            fontSizeMobile={14}
            lineHeight={1}
          >
            <Col alignItems='center' gap={4}>
              <Emoji type='message' size={18} />
              {pluralizeStr(props.messages, 'ответ', 'ответа', 'ответов')}
            </Col>
          </Text>
        </Row>
      </Col>
    </UI.Panel>
  )
}

function Radio(props: {
  type: NonNullable<OfferItemProps['type']>
  active?: boolean
}) {
  return (
    <div
      class={classNames(styles.radio, styles[props.type], {
        [styles.active]: props.active,
      })}
    />
  )
}
